<template>
  <div v-if="hasPrev || forceNextBtn">
    <v-footer fixed elevation="7" padless class="hidden-sm-and-up zindex">
      <v-card
        flat
        tile
        width="100%"
        class="text-center pb-4"
        :color="$vuetify.theme.dark ? 'grey darken-3' : 'white lighten-1 '"
      >
        <v-card-text>
          <v-row align="center" justify="space-around">
            <v-col>
              <v-row align="center" justify="space-around">
                <v-btn v-if="hasPrev" class="ma-2" rounded outlined fab small @click="emitPrev">
                  <v-icon>mdi-arrow-left</v-icon>
                </v-btn>
              </v-row>
              <v-row align="center" v-if="hasPrev" justify="space-around">
                {{ $t("back") }}
              </v-row>
            </v-col>

            <v-col>
              <v-row align="center" justify="space-around">
                <v-btn
                  v-if="hasNext"
                  class="ma-2"
                  rounded
                  outlined
                  fab
                  small
                  color="success"
                  @click="emitNext"
                  :disabled="disableNext"
                >
                  <v-icon>mdi-arrow-right</v-icon>
                </v-btn>
              </v-row>
              <v-row v-if="hasNext" align="center" justify="space-around">
                {{ $t("next") }}
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-footer>
    <v-container>
      <v-card-actions class="progressContainer card-actions hidden-sm-and-down d-sm-inline">
        <v-row>
          <v-btn class="ma-4" v-if="hasPrev" id="prev" x-large elevation="0" @click="emitPrev">
            <v-icon>mdi-arrow-left</v-icon>
            {{ $t("back") }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            class="ma-4"
            v-if="hasNext"
            id="next"
            :disabled="disableNext"
            x-large
            elevation="0"
            @click="emitNext"
            color="green"
          >
            {{ $t("next") }}
            <v-icon>mdi-arrow-right</v-icon>
          </v-btn>
        </v-row>
      </v-card-actions>
    </v-container>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class BackAndForthFooter extends Vue {
  @Prop({ default: true })
  hasNext!: boolean;

  @Prop({ default: true })
  hasPrev!: boolean;

  @Prop({ default: false })
  forceNextBtn!: boolean;

  @Prop({ default: false })
  disableNext!: boolean;

  emitNext() {
    this.$emit("next", true);
  }
  emitPrev() {
    this.$emit("prev", true);
  }
}
</script>
<style scoped>
.progressContainer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding-left: 28px !important;
  padding-right: 28px !important;
}

.bottomContainer {
  width: 80%;
}

.zindex {
  z-index: 4;
}
</style>
